import { type ContextData } from '@common/defaults/ContextData';
import { getThemeConfigByContext, type ThemeConfig, useThemeConfig } from '@common/hooks/useThemeConfig';
import { isDevelopment } from '@common/utils/env';

export interface HeaderThemeConfig {
    darkModeEnabled?: boolean;
}

const THEME_CONFIG: ThemeConfig<HeaderThemeConfig> = {
    defaults: {},
    byTheme: {
        ab: {
            darkModeEnabled: true,
        },
        admin: {
            darkModeEnabled: false,
        },
    },
};

export const isDarkModeEnabled = (themeConfig: HeaderThemeConfig, appEnv?: string): boolean => {
    if (themeConfig.darkModeEnabled === false) {
        return false;
    }

    return themeConfig.darkModeEnabled === true || isDevelopment || appEnv === 'quality-assurance';
};

export const isSystemDarkModeEnabled = (themeConfig: HeaderThemeConfig): boolean => {
    if (themeConfig.darkModeEnabled === false) {
        return false;
    }

    return themeConfig.darkModeEnabled === true || isDevelopment;
};

export const getThemeProviderConfig = (contextData: ContextData) =>
    getThemeConfigByContext({ config: THEME_CONFIG, contextData });

export const useThemeProviderConfig = () => useThemeConfig(THEME_CONFIG);
